import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import iconFile from "./assets/iconFile.svg"
import showFile from "./assets/showFile.svg"
import deleteFile from "./assets/deleteFile.svg"
const PlanillaCard =
  ({

    selectPlanilla,
    planilla
  }) => {

    const [editorContacto, setContacto] = useState(false);


    return (

      <DivRow key={planilla.id}>
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: "space-between",
          alignItems: "center",
          width: "-webkit-fill-available"
        }} >
          <IconItem src={iconFile} />
          <Text
            selectPlanilla={selectPlanilla}
            planilla={planilla}
          >

            {planilla.name}
          </Text>
          <IconItem src={showFile} />
          <IconItem src={deleteFile} />
        </div>

      </DivRow>
    );
  };

export default PlanillaCard;

const Text = styled.span`
width: -webkit-fill-available;
font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: ${(prop) => prop.selectPlanilla?.id === prop.planilla?.id ? '#07082c' : '#07082c'}  ;
`;
const DivRow = styled.div`
width: -webkit-fill-available;
padding: 0px 0px;
display: flex;
flex-direction: row;
gap: 5px;
height: auto;
align-content: flex-start;
justify-content: start;
align-items: center;
border-radius:8px;
cursor: pointer;
background-color: 'transparent' ;
transition: all 0.3s ease-in-out;
&:hover{
    will-change: transform;
}
&:active{
    will-change: transform; 
}
`;

const IconItem = styled.img`
width:24px;
height:24px;
min-height:24px;
min-width:24px;
padding:5px;
border-radius:50%;
border-color: #dadce0;
cursor:pointer;
&:hover{
    border-color: #dadce0;
    box-shadow: rgb(84 28 28 / 34%) 0 1px 1px;
    background-color: #fcfcfc;
    border-radius:50%;
    padding:5px;
}
&:active{
    border-color: #dadce0;
    box-shadow: rgb(84 28 28 / 34%) 0 1px 1px;
    background-color: #fcfcfc;
    border-radius:50%;
    padding:5px;
}
`;
